import { render, staticRenderFns } from "./HotMaterial.vue?vue&type=template&id=605e1a47&scoped=true"
import script from "./HotMaterial.vue?vue&type=script&lang=js"
export * from "./HotMaterial.vue?vue&type=script&lang=js"
import style0 from "./HotMaterial.vue?vue&type=style&index=0&id=605e1a47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e1a47",
  null
  
)

export default component.exports